import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { createGenericError } from 'utils/createGenericError'
import { getAccountOwners as getAccountOwnersApi } from '../api'

export const GET_ACCOUNT_OWNERS = 'GET_ACCOUNT_OWNERS'
export const GET_ACCOUNT_OWNERS_SUCCESS = 'GET_ACCOUNT_OWNERS_SUCCESS'
export const GET_ACCOUNT_OWNERS_FAILURE = 'GET_ACCOUNT_OWNERS_FAILURE'

export const getAccountOwners = (
  dispatch: Dispatch,
  accountNumber: string,
  onError: (error: string) => void
) => {
  dispatch({ type: GET_ACCOUNT_OWNERS, accountNumber })
  getAccountOwnersApi(accountNumber)
    .then((response: AxiosResponse) => {
      dispatch({
        type: GET_ACCOUNT_OWNERS_SUCCESS,
        accountOwners: response.data,
      })
    })
    .catch((error: ApexApiError) => {
      createGenericError(error, dispatch, GET_ACCOUNT_OWNERS_FAILURE, onError)
    })
}
